<template>
  <div class="info-bar">
    <div class="info-content">
      <div class="info-item">
        <span class="label">工厂:</span>
        <span class="value">{{ workOrder.factoryName || '-' }}</span>
      </div>
      <span class="separator">|</span>
      
      <div class="info-item">
        <span class="label">车间:</span>
        <span class="value">{{ workOrder.workshopName || '-' }}</span>
      </div>
      <span class="separator">|</span>
      
      <div class="info-item">
        <span class="label">产线:</span>
        <span class="value">{{ workOrder.productionLineName || '-' }}</span>
      </div>
      <span class="separator">|</span>
      
      <div class="info-item">
        <span class="label">工单号:</span>
        <span class="value">{{ workOrder.workOrderNo || '-' }}</span>
      </div>
      <span class="separator">|</span>
      
      <div class="info-item">
        <span class="label">产品:</span>
        <span class="value">{{ workOrder.productName || '-' }}</span>
      </div>
      <span class="separator">|</span>
      
      <div class="info-item">
        <span class="label">批次:</span>
        <span class="value">{{ workOrder.productionBatch || '-' }}</span>
      </div>
      <span class="separator">|</span>
      
      <div class="info-item">
        <span class="label">日期:</span>
        <span class="value">{{ formattedPlanDate }}</span>
      </div>
    </div>
    
    <!-- 插槽：用于放置返回按钮等额外内容 -->
    <div v-if="$slots.extra" class="extra-actions">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBar',
  props: {
    workOrder: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedPlanDate() {
      if (!this.workOrder.planDate) return '-'
      
      // 如果已经是 yyyy-MM-dd 格式，直接返回
      if (/^\d{4}-\d{2}-\d{2}$/.test(this.workOrder.planDate)) {
        return this.workOrder.planDate
      }
      
      // 否则解析日期并格式化为 yyyy-MM-dd
      try {
        const date = new Date(this.workOrder.planDate)
        if (isNaN(date.getTime())) return this.workOrder.planDate
        
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        
        return `${year}-${month}-${day}`
      } catch (e) {
        return this.workOrder.planDate
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-bar {
  min-height: 50px;
  background: rgba(0, 255, 255, 0.05);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  gap: 20px;
  box-shadow: 0 0 15px rgba(0, 255, 255, 0.1);
}

.info-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
  padding: 10px 0;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 5px;
  
  .label {
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
  }
  
  .value {
    color: #00ffff;
    font-size: 14px;
    font-weight: 500;
    text-shadow: 0 0 5px rgba(0, 255, 255, 0.3);
  }
}

.separator {
  color: rgba(0, 255, 255, 0.3);
  font-size: 14px;
}

.extra-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-left: 20px;
  border-left: 1px solid rgba(0, 255, 255, 0.2);
}
</style>
